import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Drawer,
  DatePicker,
  notification
} from "antd";

import { create as CreatePatient } from "../../api/Patient";
import { update as UpdatePatient } from "../../api/Patient";

import { formatFirstname, formatLastname } from '../../utils';

import moment from "moment";

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3"
  },
};

const PatientForm = (props) => {
  const { patient } = props;
  const [visible, setVisible] = useState(false);
  const [age, setAge] = useState(null);
  const [form] = Form.useForm();

  const onFinish = async () => {
    form.validateFields().then(async (values) => {
      values.birthdate = values.birthdate.startOf("day").toISOString(true);

      if (patient) {
        await UpdatePatient(patient.id, values);
        props.onCreated();
      } else {
        let newPatient = await CreatePatient(values);
        props.onCreated(newPatient);
      }

      onClose();
    })
    .catch((error) => {
      notification['error']({
        message: "Pensez à bien compléter tous les champs requis."
      });
    });
  };

  const onClose = () => {
    form.resetFields();

    let initialValues = {
      firstname: null,
      lastname: null,
      birthdate: moment().subtract(35, "years"),
    };
    form.setFieldsValue(initialValues);
    showAge(initialValues.birthdate);

    props.onClose();
  };

  /**
   *
   * @param {*} errorInfo
   */
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  /**
   *
   * @param {*} value
   */
  const onChangeBirthdateHandler = (value) => {
    console.log(value);

    if (value !== null) {
      showAge(value);
    }
  };

  /**
   *
   * @param {*} birthdate
   */
  const showAge = (birthdate) => {
    let age = moment().diff(birthdate, "years");
    setAge(age);
  };

  useEffect(() => {
    setVisible(props.visible);
  });

  let initialValues = {
    firstname: null,
    lastname: null,
    birthdate: moment().subtract(35, "years"),
  };

  useEffect(() => {
    if (patient) {
      initialValues = {
        firstname: formatFirstname(patient.firstname),
        lastname: formatLastname(patient.lastname),
        birthdate: moment(patient.birthdate)
      };
    }

    form.setFieldsValue(initialValues);
    showAge(initialValues.birthdate);
  }, [patient]);

  let drawerTitle = "Ajout d'un nouveau patient";
  if (patient) {
    drawerTitle = "Modification d'un patient";
  }

  return (
    <Drawer
      title={drawerTitle}
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      width="800px"
      key="left"
      footer={
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Annuler
          </Button>
          <Button onClick={onFinish} type="primary">
            Enregistrer
          </Button>
        </div>
      }
    >
      <Form
        {...layout}
        form={form}
        name="patient"
        initialValues={initialValues}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="Prénom"
          name="firstname"
          rules={[{ required: true, message: 'Le prénom est obligatoire' }]}
        >
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item
          label="Nom"
          name="lastname"
          rules={[{ required: true, message: 'Le nom est obligatoire' }]}
        >
          <Input className="ant-input-text"/>
        </Form.Item>
        <Form.Item label="Date de naissance" name="birthdate">
          <DatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            onChange={onChangeBirthdateHandler}
          />
        </Form.Item>
        <Form.Item label="Âge">
          <span>{age} ans</span>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default PatientForm;
